import React from "react";
import MaterialTable, {MTableToolbar} from "material-table";
import tableicons from "../tableicons";
import {ajustesResources, diferenciasResources, inventarioResources, revisarResources} from "../endpoints";
import CheckIcon from "@material-ui/icons/Check";
import CreateIcon from "@material-ui/icons/Create";
import DeleteIcon from "@material-ui/icons/Delete";
import DialogEditarCantidadConteo from "./DialogEditarCantidadConteo";
import SnackbarAlert from "./SnackbarAlert";
import DialogEliminarConteo from "./DialogEliminarConteo";
import DialogRevisarConteo from "./DialogRevisarConteo";
import BlockIcon from '@material-ui/icons/Block';
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";
import AgregarConteo from "./AgregarConteo";
import useToken from "../useToken";

class TablaDetalleDiferencias extends React.Component{
    constructor(props) {
        super(props);
        this.state={
            selectedRow:null,
            idProducto:props.idProducto,
            datos:[],
            editar_conteo:false,
            datos_conteo:"",
            eliminar_conteo:false,
            revisar: false,
            desrevisar: false,
            agregar_conteo:false,
            estado_inv:null,
            origen: props.origen,
            tipo: props.tipo,
            app : useToken.getUser().app,
            revisar_conteo_cero: false,
            desrevisar_conteo_cero: false,

        }
    }

    componentDidMount() {
        this.obtenerDiferencias()
        this.getEstadoActualInventario()
    }

    obtenerDiferencias = () =>{
        this.setState({openSnack:false, severity: null, message:null})
        if (this.state.tipo === 'diferencias'){
            diferenciasResources.getDifProducto(this.state.idProducto).then(async response => {
                if (response) {
                    return await response.json();
                }
            }).then(result => {
                if(result.status_code === 200){
                    this.setState({datos:result.diferencias}, ()=>{
                        if ( result.diferencias.length===0 ){
                            this.verificaConteoCeroRevisado()
                        }
                    })
                }
                else if (result.status_code === 401){
                    this.setState({openSnack:true, severity:result.severity, message:result.message})
                }
                else{
                    throw new Error('Something went wrong ...');
                }
            }).catch(error=> {
                console.log(error)
            });
        }
        else{
            ajustesResources.getDetallesProducto(this.state.idProducto).then(async response => {
                if (response) {
                    return await response.json();
                }
            }).then(result => {
                if(result.status_code === 200){
                    this.setState({datos:result.diferencias})
                }
                else if (result.status_code === 401){
                    this.setState({openSnack:true, severity:result.severity, message:result.message})
                }
                else{
                    throw new Error('Something went wrong ...');
                }
            }).catch(error=> {
                console.log(error)
            });
        }

    }

    verificaConteoCeroRevisado=()=>{
        revisarResources.verificaConteoCeroRevisado(this.state.idProducto).then(async response => {
            if (response) {
                return await response.json()
            }
        }).then(result =>{
            if(result){
                this.setState({desrevisar_conteo_cero:true})
            }
            else{
                this.setState({revisar_conteo_cero:true})
            }
        }).catch(error=> {
            console.log(error)
        });
    }

    getEstadoActualInventario = ()=>{
        inventarioResources.getEstadoActual().then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result => {
            if(result.status_code === 200){
                this.setState({estado_inv:result.estado})
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            console.log(error)
        });
    }

    handleClose = () =>{
        this.setState({editar_cantidad:false,eliminar_conteo:false,revisar:false,desrevisar: false, agregar_conteo:false,})
    }

    refrescar = (estado, severity) => {
        this.setState({
            agregar_conteo: false,
            editar_cantidad: false,
            eliminar_conteo: false,
            revisar: false,
            desrevisar: false,
            openSnack: false,   // primero cerramos el snack
            severity: null,
            message: null,
            desrevisar_conteo_cero:!this.state.desrevisar_conteo_cero,
            revisar_conteo_cero:!this.state.revisar_conteo_cero,

        }, () => {
            if (severity === "success") {
                this.obtenerDiferencias();
            }

            // pequeño delay para reabrir el snack
            setTimeout(() => {
                this.setState({
                    openSnack: true,
                    severity: severity,
                    message: estado,
                });
            }, 50);
        });
    };

    enviar_datos_conteo = (row) =>{
        this.setState({editar_cantidad:true, datos_conteo:row})
    }

    para_revisar_conteo = (tipo, row)=>{
        if (tipo === "revisar"){
            this.setState({revisar:true, datos_conteo:row})
        }
        else{
            this.setState({desrevisar:true, datos_conteo:row})
        }
    }
    enviar_datos_eliminar = (row) =>{
        this.setState({eliminar_conteo:true, datos_conteo:row})
    }

    revisar_conteo_cero = ()=>{
        revisarResources.revisarConteoCero(this.state.idProducto).then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result => {
            if(result.message){
                this.refrescar(result.message,result.severity)
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            this.refrescar("Ha ocurrido un error inesperado","error")
            console.log(error)
        });
    }

    desrevisar_conteo_cero = ()=>{
        revisarResources.desrevisarConteoCero(this.state.idProducto).then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result => {
            if(result.message){
                this.refrescar(result.message,result.severity)
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            this.refrescar("Ha ocurrido un error inesperado","error")
            console.log(error)
        });
    }


    render() {
        return (
            <div>
                <MaterialTable
                    components={{
                        Toolbar: props => (
                            <div>
                                <MTableToolbar {...props} />
                                <Grid container direction="row" justifyContent="flex-end" alignItems="center" spacing={2} style={{padding:10, marginBottom:10}}>
                                    {this.state.revisar_conteo_cero &&
                                    <Grid item>
                                        <Button startIcon={
                                            <CheckIcon/>} variant="contained" color="primary" onClick={()=>{this.revisar_conteo_cero()}}>
                                            Marcar como revisado</Button>
                                    </Grid>}
                                    {this.state.desrevisar_conteo_cero &&
                                        <Grid item>
                                            <Button startIcon={
                                                <CheckIcon/>} variant="contained" color="primary" onClick={()=>{this.desrevisar_conteo_cero()}}>
                                                Marcar como no revisado</Button>
                                        </Grid>}
                                    <Grid item>
                                        <Button startIcon={
                                            <AddIcon/>} variant="contained" color="primary" onClick={()=>{this.setState({agregar_conteo:true})}}>
                                            Agregar conteo</Button>
                                    </Grid>
                                </Grid>
                            </div>
                        ),
                    }}
                    actions={[
                        rowData => ({
                            icon:  () => <CheckIcon style={{fontSize:27, margin:4}}/>,
                            tooltip: 'Marcar como revisado',
                            onClick: (event, rowData) => this.para_revisar_conteo("revisar",rowData),
                            hidden: rowData.revisado === true
                        }),
                        rowData => ({
                            icon:  () => <BlockIcon style={{fontSize:27, margin:4}}/>,
                            tooltip: 'Marcar como no revisado',
                            onClick: (event, rowData) => this.para_revisar_conteo("desrevisar",rowData),
                            hidden: rowData.revisado !== true
                        }),
                        {
                            icon:  () => <CreateIcon style={{fontSize:27, margin:4}}/>,
                            tooltip: 'Editar conteo',
                            onClick: (event, rowData) => this.enviar_datos_conteo(rowData),
                        },
                        {
                            icon:  () => <DeleteIcon style={{fontSize:27, margin:4}}/>,
                            tooltip: 'Eliminar conteo',
                            onClick: (event, rowData) => this.enviar_datos_eliminar(rowData),
                        },
                    ]}
                    localization={{
                        toolbar: {
                            searchPlaceholder: 'Buscar',
                        },
                        header: {
                            actions: 'Acciones'
                        },
                        body:{
                            emptyDataSourceMessage: 'No hay datos para mostrar'
                        }
                    }}
                    options={{
                        pageSize: 50,
                        pageSizeOptions: [10, 25, 50, 100],
                        actionsColumnIndex: -1,
                        rowStyle: rowData => ({
                            backgroundColor: (this.state.selectedRow === rowData.tableData.id) ? '#dbe9fc' : '#FFF'
                        }),
                        searchFieldStyle: {
                            width: "auto",
                        },
                        padding: "dense"
                    }}
                    icons={tableicons}
                    title=" "
                    data={this.state.datos}
                    columns={[
                        { title: 'Ubicación', field: 'p',
                            cellStyle: {
                                width: 400,
                                maxWidth: 400,
                            },
                            headerStyle: {
                                width: 400,
                                maxWidth: 400
                        }},
                        { title: 'Tag', field: 'tag'},
                        { title: 'Man/Esp', field: 'tipo_tag',
                            hidden: (this.state.app !== 'walmart' && this.state.app !== 'walmart_parciales'),
                            render: rowData => (rowData.tipo_tag === 'MANDATORIO/ESPEJO' ? <CheckIcon/> : null),},
                        { title: 'Bin', field: 'bin', hidden: (this.state.app !== 'walmart' && this.state.app !== 'walmart_parciales')},
                        { title: 'Cód. escan.', field: 'codigo'},
                        { title: 'Cód. tipo', field: 'codigo_tipo'},
                        { title: 'U.M.', field: 'um'},
                        { title: '[x]', field: 'factor'},
                        { title: 'Cantidad Final', field: 'cantidad'},
                        { title: 'Cantidad Capt.', field: 'cantidad'},
                        { title: 'Revisado', field: 'revisado',
                            render: rowData => (rowData.revisado ? <CheckIcon/> : null),}
                    ]}
                    onRowClick={(event, rowData) => this.setState({selectedRow: rowData.tableData.id})}
                />
                {this.state.agregar_conteo && <AgregarConteo origen={this.state.origen} tag={''} handleClose={this.handleClose} refrescar={this.refrescar} articulo={this.state.idProducto}/>}

                {this.state.editar_cantidad && <DialogEditarCantidadConteo origen={this.state.origen} tag={this.state.datos_conteo.tag} refrescar={this.refrescar} tipo={"agrupado"} handleClose={this.handleClose} conteo={this.state.datos_conteo}/>}

                {this.state.eliminar_conteo && <DialogEliminarConteo refrescar={this.refrescar} tag={this.state.datos_conteo.tag} tipo={"agrupado"} handleClose={this.handleClose} conteo={this.state.datos_conteo}/>}

                {this.state.openSnack? <SnackbarAlert severity={this.state.severity} message={this.state.message}/> : null}

                {this.state.revisar && <DialogRevisarConteo origen={this.state.origen} revisar={true} tag={this.state.datos_conteo.tag} tipo={"agrupado"} handleClose={this.handleClose} conteo={this.state.datos_conteo} refrescar={this.refrescar}/>}

                {this.state.desrevisar && <DialogRevisarConteo origen={this.state.origen} revisar={false} tag={this.state.datos_conteo.tag} tipo={"agrupado"} handleClose={this.handleClose} conteo={this.state.datos_conteo} refrescar={this.refrescar}/>}
            </div>
        );
    }
}

export default TablaDetalleDiferencias;